module.exports = __webpack_public_path__ + "img/documents-req.d62dd37d.svg";